//Convert incoming tags to dropbox format
export default function normalizeTags(options) {
  return options.map((option) => ({
    label: option.Text,
    value: option.Id,
  }));
}
